import { SidenavIcon, SidenavRow } from '@app/components/layout/sidenav/base';
import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { getAppUserDisplayName, getUserInitials } from '@app/helpers/user';
import { UserRole } from '@mi-front/core';
import { Box, Tooltip } from '@mui/material';
import { useIsImpersonationOn } from '../impersonation/hooks/useIsImpersonationOn';
import { AdminImpersonationCta } from './AdminImpersonationCta';
export function UserInfo() {
  const { user, auth0User } = useAuth();
  const avatar = user.avatar || auth0User.picture;

  return (
    <>
      <SidenavRow sx={{ marginBottom: '0.75rem', paddingTop: '0.5rem' }}>
        {!avatar ? (
          <SidenavIcon
            sx={{
              background: '#0e667f',
              display: 'block',
              letterSpacing: '0.1rem',
              fontSize: '0.9rem',
            }}
          >
            {getUserInitials(user)}
          </SidenavIcon>
        ) : (
          <SidenavIcon
            component="img"
            {...({
              alt: 'User avatar',
              src: avatar,
            } as any)}
          />
        )}
        {user.role === UserRole.SUPERADMIN ? (
          'Admin'
        ) : (
          <Tooltip title={user.email} placement="top">
            <Box
              sx={{
                flex: '1 1',
                alignSelf: 'center',
                fontSize: '0.85rem',
                position: 'relative',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              <div>{getAppUserDisplayName(user, 'min')}</div>
            </Box>
          </Tooltip>
        )}
      </SidenavRow>
      {useIsImpersonationOn() && <AdminImpersonationCta />}
    </>
  );
}
